export default __webpack_public_path__ + "static/distro-1dc297fa0b303dc23b46168bc8313132.png";